export const RISK_LEVEL = {
	NONE: 1,
	LOW: 2,
	MEDIUM: 3,
	HIGH: 4,
};
